import React from 'react';
import { useHistory } from "react-router-dom";
import { Col, Row } from 'react-bootstrap';
import EGSelection from '../Filters/MultiEGSelection';
import SearchFilter from '../Filters/SearchFilter';
import ActionButton from './ActionButton';

const BoardHeader = () => {
    const history = useHistory();

    return (
        <Row lg={12} md={12} sm={12} className="kanban-header">
            <Col lg={3} md={3} sm={3}>
                <h4>Manage Equipment Groups</h4>
            </Col>
            <Col lg={4} md={4} sm={4}>
                <EGSelection />
            </Col>
            <Col lg={5} md={5} sm={5}>
                <Row className='align-items-center'>
                    <Col className="action-btn">
                        <ActionButton />
                    </Col>
                    <Col className="split">
                        <div className="splitter" />
                    </Col>
                    <Col className="search-input-container pr-0">
                        <SearchFilter />
                    </Col>
                    <Col className="split">
                        <div className="splitter" />
                    </Col>
                    <Col
                        title="Equipment Group List"
                        className="split pl-0"
                        onClick={() => {
                            const currentPathname = history.location.pathname;
                            const newPathname = currentPathname.replace('/kanban', '/list');
                            history.push(newPathname);
                        }}>
                        <i className="fa fa-list eg-list-icon" />
                    </Col>
                </Row>
            </Col>
        </Row>
    )
};

export default BoardHeader;